var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxsFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.125,22A1.941,1.941,0,0,0,19,20V8L13.375,2h-7.5A1.941,1.941,0,0,0,4,4V20a1.941,1.941,0,0,0,1.875,2ZM12.438,4l4.688,5H12.438ZM6.813,8H9.625v2H6.813Zm0,4h9.375v2H6.813Zm0,4h9.375v2H6.813Z",
    transform: "translate(-4 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsFile);
export default __webpack_public_path__ + "static/media/bxs-file.0dd9d0a60f5e18c58d89dde42f87fb97.svg";
export { ForwardRef as ReactComponent };